module.exports = __webpack_public_path__ + "static/media/vippssearch.7b146fc5.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Signup/Media/vippssearch.PNG
// module id = 250
// module chunks = 0